const units = ['B', 'KB', 'MB', 'GB', 'TB'];

// 1024-based size with one decimal from KB on, e.g. "2.9 MB"; unitLabel translates the unit
const formatByteSize = (byteSize: number, unitLabel: (unit: string) => string): string => {
  let value = byteSize;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < units.length - 1) {
    value /= 1024;
    unitIndex++;
  }
  const digits = unitIndex === 0 ? 0 : 1;
  const formatted = value.toLocaleString('en-US', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  return `${formatted} ${unitLabel(units[unitIndex])}`;
};

export default formatByteSize;
